import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { MY_ACCOUNT_MODAL } from '~/Config/Modals';
import { openModal } from '~/Redux/Modules/Modal';

class MyAccountRouter extends Component {
  state = { redirectToHome: false };

  componentDidMount = () => {
    const {
      isModalOpen,
      location: { pathname },
      openModal,
    } = this.props;
    if (!isModalOpen && pathname == '/account') return openModal();
  };

  componentWillReceiveProps = nextProps => {
    const { isModalOpen } = this.props;
    if (isModalOpen && !nextProps.isModalOpen) this.setState({ redirectToHome: true });
  };

  render() {
    return this.state.redirectToHome ? <Redirect to="/" /> : null;
  }
}

MyAccountRouter.propTypes = {
  isModalOpen: propTypes.bool,
  location: propTypes.object,
  openModal: propTypes.func,
};

const mapStateToProps = ({ Modal }) => {
  return {
    isModalOpen: Modal.modalsOpen.includes(MY_ACCOUNT_MODAL),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => dispatch(openModal(MY_ACCOUNT_MODAL)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountRouter);
